import React from "react";
import { motion } from "framer-motion";
import { MapPin, Briefcase } from "lucide-react";

export default function About({ profile }) {
  return (
    <section id="about" className="py-24 md:py-32 relative" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <SectionHeader number="01" overline="About" title="A quantitative mind, wired for agents." />

        <div className="grid lg:grid-cols-12 gap-10 mt-14">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7 flex flex-col md:flex-row gap-8 items-start"
          >
            <div className="w-32 h-32 md:w-40 md:h-40 shrink-0 rounded-full overflow-hidden border-2 border-white/10 shadow-2xl shadow-volt/10 transition-transform duration-500 hover:scale-105 hover:border-volt/30">
              <img src="/profile.jpg" alt="Profile" className="w-full h-full object-cover" />
            </div>
            <div>
              <p className="text-lg sm:text-xl text-fog-100 leading-relaxed font-normal">
                {profile?.bio}
              </p>
              <div className="mt-8 flex flex-wrap gap-4 text-fog-300">
                <InfoChip icon={<MapPin className="w-4 h-4" />} text={profile?.location || "Connecticut, USA"} />
                <InfoChip icon={<Briefcase className="w-4 h-4" />} text={`${profile?.years_experience || 7} years experience`} />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export function SectionHeader({ number, overline, title, sub }) {
  return (
    <div className="flex items-end justify-between gap-6 flex-wrap">
      <div>
        <p className="overline text-volt">[ {number} / {overline} ]</p>
        <h2 className="mt-3 font-display font-black text-3xl sm:text-5xl tracking-tighter leading-[1.02] max-w-3xl">
          {title}
        </h2>
        {sub && <p className="mt-4 text-fog-300 max-w-2xl">{sub}</p>}
      </div>
      <div className="hidden md:flex items-center gap-2 text-fog-400">
        <div className="w-16 h-px bg-white/20" />
        <span className="overline">scroll →</span>
      </div>
    </div>
  );
}

function InfoChip({ icon, text }) {
  return (
    <span className="inline-flex items-center gap-2 border border-white/10 px-3 py-1.5 text-sm">
      {icon}
      {text}
    </span>
  );
}
